"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OrganisationMember = _interopRequireDefault(require("../../OrganisationMember/OrganisationMember"));
var _GSemployeeRole = _interopRequireDefault(require("../../GSemployeeRole/GSemployeeRole"));
var _List = _interopRequireDefault(require("../../List/List"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-commission-container .inapp-content {\n  display: flex;\n  justify-content: space-between; }\n  .inapp-commission-container .inapp-content .page-accordion-generic-container {\n    width: min-content;\n    flex-grow: 1; }\n  .inapp-commission-container .inapp-content .presidents {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap; }\n    .inapp-commission-container .inapp-content .presidents .OrganisationMember-container {\n      margin: initial; }\n\n.inapp-commission-container .responsibles-text {\n  margin-left: 16px; }\n\n.list-container {\n  padding-right: 64px; }\n\n@media (max-width: 66rem) {\n  .inapp-commission-container {\n    padding-bottom: 0px; }\n    .inapp-commission-container .inapp-content {\n      flex-direction: column; }\n      .inapp-commission-container .inapp-content .page-accordion-generic-container {\n        width: 100%; }\n    .inapp-commission-container .presidents {\n      gap: 16px; }\n    .inapp-commission-container .responsibles-text {\n      margin-left: 0px; } }\n\n@media (max-width: 42rem) {\n  .inapp-commission-container .inapp-content {\n    flex-direction: column; }\n  .inapp-commission-container .presidents {\n    flex-direction: column;\n    gap: 0px; }\n  .inapp-commission-container .responsibles-text {\n    margin-left: 0px; } }\n";
  const fileName = "InAppCommission_InAppCommission";
  const element = document.querySelector("style[data-sass-component='InAppCommission_InAppCommission']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getItems = members => members?.map((el, i) => {
  return {
    content: `${el.academic_title || ''} ${el.lastname} ${el.firstname}${el.diploma_title ? ', ' + el.diploma_title : ''}${el.city ? ', ' + el.city : ''}`
  };
});
const Content = _ref => {
  let {
    members,
    presidents,
    info,
    translate,
    responsibles,
    frontend_parameter
  } = _ref;
  const items = (0, _react.useMemo)(() => getItems(members), [members]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "info"
  }, info?.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, info[0]?.name && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-15 sia-margin-03-bottom",
    dangerouslySetInnerHTML: {
      __html: info[0]?.name
    }
  }), info[0]?.description && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-10 sia-margin-05-bottom",
    dangerouslySetInnerHTML: {
      __html: info[0]?.description
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-container"
  }, items && /*#__PURE__*/_react.default.createElement(_List.default, {
    title: translate('cms.inapp.commissions.members'),
    items: items,
    variant: 'UNORDERED'
  })))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "presidents"
  }, presidents?.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, presidents?.map((president, i) => {
    return /*#__PURE__*/_react.default.createElement(_OrganisationMember.default, _extends({
      key: i
    }, president, {
      gender: null,
      professional_group_membership: president.professional_group ? president.professional_group[0].name : '',
      section_memberships: president?.sections?.map(group => group.name),
      sia_membership: president.member_type,
      picture: president.image ? 'data:image/png;base64,' + president.image : null
    }));
  }))), responsibles && responsibles.length > 0 && frontend_parameter != 'hide-responsible' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "responsibles-text sia-text-07 sia-margin-01-bottom"
  }, translate('cms.commissions.responsibles'), ":"), /*#__PURE__*/_react.default.createElement("div", {
    className: "responsibles"
  }, responsibles?.map((responsible, i) => {
    return /*#__PURE__*/_react.default.createElement(_GSemployeeRole.default, _extends({
      key: i
    }, responsible, {
      professional_function: responsible?.job,
      displayImage: false
    }));
  }))))));
};
const InAppCommission = _ref2 => {
  let {
    translate,
    data,
    frontend_parameter
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-commission-container sia-padding-02-bottom"
  }, data && /*#__PURE__*/_react.default.createElement(Content, _extends({}, data, {
    translate: translate,
    frontend_parameter: frontend_parameter
  })));
};
var _default = exports.default = InAppCommission;